
export { ShoppingBagButton } from "/codebuild/output/src3122444883/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"